import { render } from "./FadeContent.vue?vue&type=template&id=9a4335ba"
import script from "./FadeContent.vue?vue&type=script&lang=js"
export * from "./FadeContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__